import { ReactNode } from "react";

export enum DIALOG_TYPES {
  CREATE,
  MAKE_PRIVATE,
  MAKE_PUBLIC,
  SHOW_PUBLIC_URL,
  DELETE,
  ENABLE_VERSIONING,
  SUSPEND_VERSIONING
}

export type S3BucketsProps = {
  credsId: string;
  tabs: ReactNode;
};
